import React from "react";
import { Form, Input, Select, Button, Space, Row, Col, DatePicker } from "antd";
import { SearchOutlined, ReloadOutlined, SyncOutlined } from "@ant-design/icons";
import { toUtcStartOfDayIso } from "../lib/exchangeRatePeriod";

const { Option } = Select;

const ExchangeRateFilter = ({ onSearch, onReset, onRefresh, currencies = [] }) => {
    const [form] = Form.useForm();

    // 处理搜索
    const handleSearch = () => {
        const values = form.getFieldsValue();
        onSearch({
            ...values,
            effective_date: values.effective_date ? toUtcStartOfDayIso(values.effective_date) : undefined,
        });
    };

    // 处理重置
    const handleReset = () => {
        form.resetFields();
        onReset();
    };

    // 处理回车搜索
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleSearch();
        }
    };

    // 汇率来源选项
    const sourceOptions = [
        { value: "CENTRAL_BANK", label: "央行汇率" },
        { value: "COMMERCIAL_BANK", label: "商业银行" },
        { value: "API", label: "API接口" },
        { value: "MANUAL", label: "手动录入" },
        { value: "MIGRATED", label: "数据迁移" },
    ];

    // 状态选项
    const statusOptions = [
        { value: true, label: "当前有效" },
        { value: false, label: "已过期" },
    ];

    return (
        <Form form={form} layout="inline" className="filter-form">
            <Row gutter={[16, 16]} style={{ width: "100%" }}>
                {/* 第一行：筛选条件 */}
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item name="from_currency" label="源货币">
                        <Select
                            placeholder="请选择源货币"
                            allowClear
                            showSearch
                            optionFilterProp="label"
                        >
                            {currencies.map((currency) => (
                                <Option key={currency.code} value={currency.code} label={`${currency.code} - ${currency.name}`}>
                                    {currency.code} - {currency.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item name="to_currency" label="目标货币">
                        <Select
                            placeholder="请选择目标货币"
                            allowClear
                            showSearch
                            optionFilterProp="label"
                        >
                            {currencies.map((currency) => (
                                <Option key={currency.code} value={currency.code} label={`${currency.code} - ${currency.name}`}>
                                    {currency.code} - {currency.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item name="source" label="汇率来源">
                        <Select
                            placeholder="请选择汇率来源"
                            allowClear
                        >
                            {sourceOptions.map((option) => (
                                <Option key={option.value} value={option.value}>
                                    {option.label}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item name="is_current" label="状态">
                        <Select
                            placeholder="请选择状态"
                            allowClear
                        >
                            {statusOptions.map((option) => (
                                <Option key={option.value} value={option.value}>
                                    {option.label}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item name="effective_date" label="指定日期">
                        <DatePicker
                            style={{ width: "100%" }}
                            placeholder="选择查询日期"
                            format="YYYY-MM-DD"
                        />
                    </Form.Item>
                </Col>

                {/* 第二行：操作按钮 */}
                <Col xs={24}>
                    <Form.Item>
                        <Space>
                            <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch}>
                                搜索
                            </Button>
                            <Button icon={<ReloadOutlined />} onClick={handleReset}>
                                重置
                            </Button>
                            <Button icon={<SyncOutlined />} onClick={onRefresh}>
                                刷新
                            </Button>
                        </Space>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};

export default ExchangeRateFilter;
